import type { StateType } from '../../lib/types/state-type';
import { MODULES_WITH_SUB_ROUTES } from '../../lib/module-route';

// Ein Modul meldet per routeChange, wo es gerade ist. Gemerkt wird das auch fuer ein verstecktes
// Modul: der naechste Rail-Klick oeffnet es wieder dort.
export function setModuleRoute(state: StateType, parameters: unknown[]): StateType {
  const moduleName = parameters[0] as string;
  const subRoute = parameters[1] as string;

  if (!MODULES_WITH_SUB_ROUTES.includes(moduleName) || state.moduleRoutes[moduleName] === subRoute) {
    return state;
  }

  return { ...state, moduleRoutes: { ...state.moduleRoutes, [moduleName]: subRoute } };
}
